/**
 * All services state definitions
 */

import * as Activity from "./activity/state";
import * as Form from "./form/state";
import * as App from "./app/state";
import * as Auth from "./auth/state";

const $state = {
  Activity,
  Form,
  App,
  Auth,
};

export default $state;
